import { AfterViewInit, ChangeDetectorRef, Directive, ElementRef, inject, Input } from '@angular/core';

@Directive({ selector: 'input[appCustomAutofocus]' })
export class CustomAutofocusDirective implements AfterViewInit {
  private cdRef = inject(ChangeDetectorRef);
  private el = inject(ElementRef);

  @Input() appCustomAutofocus!: any;

  ngAfterViewInit(): void {
    if (this.appCustomAutofocus === '' || this.appCustomAutofocus) {
      this.el.nativeElement.focus();
      this.el.nativeElement.scrollIntoView();
      this.cdRef.detectChanges();
    }
  }
}
